// @ts-nocheck
/* eslint-disable */
export const arrowLeftIcon = {
    data: `<svg viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.0625 10.125L1.9375 6L6.0625 1.875" stroke="currentColor" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-left' as const
};